import config from "@/config/config";
import {
  formatUnits,
  parseUnits,
  readContract,
  writeContractAndWait,
} from "../viem";
import MafiaBulletTokenAbi from "../../abis/MafiaBulletToken.json";

const contractAddress = config.bulletTokenAddress;
const abi = MafiaBulletTokenAbi;

export const balanceOfBulletToken = async (address: string) => {
  const balanceRaw = await readContract<string>({
    address: contractAddress,
    abi,
    functionName: "balanceOf",
    args: [address],
  });
  const decimalsRaw = Number(
    await readContract<string>({
      address: contractAddress,
      abi,
      functionName: "decimals",
    })
  );

  return Number(formatUnits(balanceRaw, decimalsRaw.toString()));
};

export const getBulletTokenAllowance = async (from: string, to: string) => {
  const allowanceRaw = await readContract({
    address: contractAddress,
    abi,
    functionName: "allowance",
    args: [from, to],
  });
  const decimalsRaw = await readContract({
    address: contractAddress,
    abi,
    functionName: "decimals",
  });
  const allowance = typeof allowanceRaw === "string" ? allowanceRaw : "0";
  const decimals = Number(typeof decimalsRaw === "string" ? decimalsRaw : "0");
  return Number(formatUnits(allowance, decimals));
};

export const approveBulletToken = async (
  amount: number,
  to: string,
  account: string
) => {
  const decimals = Number(
    await readContract<string>({
      address: contractAddress,
      abi,
      functionName: "decimals",
    })
  );
  const data = await writeContractAndWait({
    address: contractAddress,
    abi,
    functionName: "approve",
    args: [to, parseUnits(amount.toFixed(decimals), decimals)],
    account,
  });
  return data;
};

export const depositBulletToken = async (amount: number, account: string) => {
  const decimals = Number(
    await readContract<string>({
      address: contractAddress,
      abi,
      functionName: "decimals",
    })
  );

  const data = await writeContractAndWait({
    address: contractAddress,
    abi,
    functionName: "depositBullet",
    args: [parseUnits(Number(amount).toFixed(decimals), decimals)],
    account,
  });
  return data;
};
